import type { FC } from 'react';
import type { LineRowScoresProps } from '@/types';
import styles from './LineRowScoresCyber.module.scss';
export const LineRowScoresCyber: FC<LineRowScoresProps> = ({
  line
}) => {
  const isHaveScore = typeof line.stats?.competitorStats?.[0].totalScore === 'number' || typeof line.stats?.competitorStats?.[1].totalScore === 'number';
  if (!isHaveScore) {
    return null;
  }
  return <div className={styles.scores} data-sentry-component="LineRowScoresCyber" data-sentry-source-file="LineRowScoresCyber.tsx">
      <span className={styles.score}>{line.stats?.competitorStats?.[0].totalScore}</span>
      <span className={styles.score}>:</span>
      <span className={styles.score}>{line.stats?.competitorStats?.[1].totalScore}</span>
    </div>;
};